document.addEventListener('DOMContentLoaded', function () {
  const backToTopButton = document.querySelector('.qld__btn--back-to-top');

  if (!backToTopButton) {
    return; // Exit if the button doesn't exist
  }

  // Show or hide the button based on scroll position
  window.addEventListener('scroll', function () {
    if (window.scrollY > 200) {
      backToTopButton.style.display = 'block';
    } else {
      backToTopButton.style.display = 'none';
    }
  });

  function toggleBackToTopButton() {
    if (window.scrollY > 200) {
      backToTopButton.style.display = 'block';
    } else {
      backToTopButton.style.display = 'none';
    }
  }

  // Run on page load
  window.addEventListener('load', toggleBackToTopButton);

  // Run on scroll
  window.addEventListener('scroll', toggleBackToTopButton);
});